import { render, staticRenderFns } from "./CustomSnackbar.vue?vue&type=template&id=6114bf57&"
import script from "./CustomSnackbar.vue?vue&type=script&lang=js&"
export * from "./CustomSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports